import { render } from "./AnswerEvaluation.vue?vue&type=template&id=a8adf9aa"
import script from "./AnswerEvaluation.vue?vue&type=script&lang=js"
export * from "./AnswerEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__